import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

const getSearchStoresByNumber = async (ctx: QueryFunctionContext) => {
  const {data}: {data: ISearchStoresList} = await request.get(
    `api/v2/store/search-store-by-number?phone_number=${ctx.queryKey[1]}`,
  );
  return data;
};

export default getSearchStoresByNumber;
